import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, getCurrentInstance } from 'vue'
import moment from 'moment'

import QuilityAPI from '@/store/API/QuilityAPI'
import { NoticePopup } from '@/store/API/PopupAcknowledgements'
import { parseContentWithMultipleFML } from '../utils/fmlToken'
import { checkPerformDashFml } from '../utils/PerformDashFML'
import QButton from '@/modules/shared/components/QButton.vue'
import FmlCard from './FmlCard.vue'
import PerformDashFmlCard from './PerformDashFmlCard.vue'
import PerformDashSubmitIcon from './PerformDashSubmitIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCardWithFml',
  props: {
    message: null,
    doNotSubmitFml: { type: Boolean },
    hasSubmitted: { type: Boolean },
    hideControls: { type: Boolean },
    hideSnooze: { type: Boolean },
    color: null,
    loading: { type: Boolean },
    elevation: null
  },
  emits: ["acknowledgeAndClose", "snoozeAndClose"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'acknowledgeAndClose'): void;
	(e: 'snoozeAndClose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	message: NoticePopup;
	doNotSubmitFml?: boolean;
	hasSubmitted?: boolean;
	hideControls?: boolean;
	hideSnooze?: boolean;
	color?: string;
	loading?: boolean;
	elevation?: number | string;
}





const agentCode = (getCurrentInstance()?.proxy.$root as any).user?.AgentCode
const showError = (getCurrentInstance()?.proxy.$root as any).showError

const parsedContent = computed(() => parseContentWithMultipleFML(props.message.content))

const submittedForms = ref<string[]>([])

const currentFormIndex = ref(0)

const formDataLoading = ref(false)

const doShowDialog = ref(false)

const slugs = computed(() => {
	if (!parsedContent.value.fmlSlugs.length) { return [] }
	return parsedContent.value.fmlSlugs.map(slug => ({
		slug,
		submitted: submittedForms.value.includes(slug),
	}))
})

const isPerformDashFml = computed(() => checkPerformDashFml(parsedContent.value.fmlSlugs[currentFormIndex.value]))
const currentComponent = computed(() => isPerformDashFml.value ? PerformDashFmlCard : FmlCard)

const moveToNextAllowed = () => {
	if (!parsedContent.value.fmlSlugs.length) { return }
	const allowedTabs = parsedContent.value.fmlSlugs.filter(slug => !submittedForms.value.includes(slug))
	if (!allowedTabs.length) { return }
	const firstAllowedInd = parsedContent.value.fmlSlugs.findIndex(slug => slug === allowedTabs[0])
	if (firstAllowedInd > -1) {
		currentFormIndex.value = firstAllowedInd
	}
}

watch(() => props.message, () => {
	if (props.hasSubmitted) { return }
	currentFormIndex.value = 0
	submittedForms.value = []
	loadFormsData()
}, { deep: true })

const acknowledgeAndClose = (slug?: string) => {
	if (slug) {
		submittedForms.value = [...submittedForms.value, slug]
		const isAllSubmitted = submittedForms.value.length === parsedContent.value.fmlSlugs.length
		if (!isAllSubmitted) {
			doShowDialog.value = true
			return
		}
		submittedForms.value = []
	}
	emit('acknowledgeAndClose')
}

const confirmNextSurvey = () => {
	doShowDialog.value = false
	moveToNextAllowed()
}

const loadFormsData = async () => {
	if (slugs.value.length < 2) { return }
	formDataLoading.value = true
	try {
		const promises = slugs.value.map(item => QuilityAPI.getFormDataWithSlug(item.slug, { filter_level: 'email', ResponseDate: '-All-', itemsPerPage: -1 }, {}, agentCode))
		const responses = await Promise.all(promises)
		responses.forEach((res: any, idx: number) => {
			const slug = slugs.value[idx].slug
			if (res.error) {
				if (res.text !== 'Aborted') {
					console.error(res.text)
					showError?.('Could not load FML form responses', res.text)
				}
			} else {
				res.data.some((item: any) => {
					if (!item.SubmittedDate) { return false }
					const startDate = moment(props.message.startDate, 'YYYY-MM-DD')
					const responseSubmittedDate = moment(item.SubmittedDate, 'YYYY-MM-DD hh:mm:ss')
					if (responseSubmittedDate.isAfter(startDate)) {
						submittedForms.value = [...submittedForms.value, slug]
						return true
					}
					return false
				})
			}
		})
		moveToNextAllowed()
	} catch (err) {
		console.error(err)
		showError?.('Could not load FML form responses', err)
	} finally {
		formDataLoading.value = false
	}
}

if (!props.hasSubmitted) {
	loadFormsData()
 }

return { __sfc: true,props, emit, agentCode, showError, parsedContent, submittedForms, currentFormIndex, formDataLoading, doShowDialog, slugs, isPerformDashFml, currentComponent, moveToNextAllowed, acknowledgeAndClose, confirmNextSurvey, loadFormsData, QButton, PerformDashSubmitIcon }
}

})